var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "merged-page" },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("message.catalogCategories") }],
            select: true,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "tippy",
                  rawName: "v-tippy",
                  value: { followCursor: true, placement: "bottom-end" },
                  expression: "{ followCursor: true, placement: 'bottom-end' }",
                },
              ],
              staticClass: "custom-checkbox2",
              attrs: { content: _vm.$t("message.showCatalogCategories") },
            },
            [
              _c(
                "a-switch",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.catalogVisible,
                    callback: function ($$v) {
                      _vm.catalogVisible = $$v
                    },
                    expression: "catalogVisible",
                  },
                },
                [
                  _c("a-icon", {
                    attrs: { slot: "checkedChildren", type: "check" },
                    slot: "checkedChildren",
                  }),
                  _vm._v(" "),
                  _c("a-icon", {
                    attrs: { slot: "unCheckedChildren", type: "close" },
                    slot: "unCheckedChildren",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.openCatalog")))]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.checkPermission(_vm.PERMISSION_TYPES["catalog.update"].tr.name)
            ? _c(
                "div",
                { staticClass: "d-flex gap-5" },
                [
                  _c(
                    "a-button",
                    {
                      staticClass: "actionButtonBreadcrumb",
                      on: { click: _vm.showModal },
                    },
                    [
                      _c("md-icon", [_vm._v("add")]),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.changeTitle")) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "actionButtonBreadcrumb",
                      on: { click: _vm.isTitleModalShow },
                    },
                    [
                      _c("md-icon", [_vm._v("add")]),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.changeVisitorTitle")) +
                          "\n            "
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex w-100",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            {
              staticClass: "side-menubar-wrapper",
              staticStyle: { width: "15%" },
            },
            [_c("ContentsMenu")],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { attrs: { id: "catalog-category" } },
              [
                _vm.catalogVisible
                  ? _c("b-container", { attrs: { fluid: "" } }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12" },
                        [
                          _c(
                            "div",
                            { staticClass: "titleAlign" },
                            [
                              !!_vm.navigation.length
                                ? _c(
                                    "md-button",
                                    {
                                      staticClass: "arrow-class",
                                      on: { click: _vm.back },
                                    },
                                    [_c("md-icon", [_vm._v("arrow_back")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !!_vm.navigation.length > 0
                                ? _c("div", { staticClass: "title" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$_.last(_vm.navigation)
                                            .languageContent[_vm.$i18n.locale]
                                            .name
                                        ) +
                                        "\n                            "
                                    ),
                                  ])
                                : _c("div", { staticClass: "title" }, [
                                    _vm._v(_vm._s(_vm.catalogTitle)),
                                  ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "menus" },
                            _vm._l(_vm.catalogs, function (cat) {
                              return _vm.catalogs.length
                                ? _c(
                                    "div",
                                    { staticClass: "menu" },
                                    [
                                      _c("CatalogMenu", {
                                        attrs: {
                                          data: cat,
                                          "navigate-to": _vm.navigateTo,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e()
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _vm.navigation.length &&
                          _vm.navigation[_vm.navigation.length - 1].type ===
                            "content"
                            ? _c("CatalogContent", {
                                attrs: {
                                  data: _vm.navigation[
                                    _vm.navigation.length - 1
                                  ],
                                },
                                on: {
                                  "finish-update": function () {
                                    return _vm.back()
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          (_vm.navigation.length &&
                            _vm.navigation[_vm.navigation.length - 1].type ===
                              "menu") ||
                          (!_vm.navigation.length &&
                            _vm.checkPermission(
                              _vm.PERMISSION_TYPES["catalog.create"].tr.name
                            ))
                            ? _c(
                                "div",
                                { staticClass: "newButtons" },
                                [
                                  !_vm.isCreateMenu
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "newMenu",
                                          style: _vm.isCreateContent
                                            ? "display: none;"
                                            : "",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCreateCatalog()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("message.addNewMenu")
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm.isCreateMenu
                                    ? _c(
                                        "b-tabs",
                                        [
                                          _c("MultiContent", {
                                            ref: "MultiContent",
                                            model: {
                                              value: _vm.inCatalogTitle,
                                              callback: function ($$v) {
                                                _vm.inCatalogTitle = $$v
                                              },
                                              expression: "inCatalogTitle",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a-button",
                                            {
                                              staticClass:
                                                "actionsButtonCancel",
                                              on: { click: _vm.cancelMenu },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.cancel")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-button",
                                            {
                                              staticClass: "actionsButton",
                                              on: { click: _vm.saveMenu },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.save")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isCreateContent
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "newMenu",
                                          style: _vm.isCreateMenu
                                            ? "display: none;"
                                            : "",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCreateCatalog(
                                                "content"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("message.content")
                                              ) +
                                              "\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm.isCreateContent
                                    ? _c(
                                        "b-tabs",
                                        [
                                          _c("MultiContent", {
                                            ref: "MultiContent",
                                            model: {
                                              value: _vm.inCatalogForm,
                                              callback: function ($$v) {
                                                _vm.inCatalogForm = $$v
                                              },
                                              expression: "inCatalogForm",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "a-button",
                                            {
                                              staticClass: "actionsButton",
                                              on: { click: _vm.cancelContent },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.cancel")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-button",
                                            {
                                              staticClass: "actionsButton",
                                              on: { click: _vm.saveContent },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.$t("message.save")
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ])
                  : _c(
                      "div",
                      [
                        _c("a-result", {
                          attrs: { title: _vm.$t("message.catalogNotOpen") },
                          scopedSlots: _vm._u([
                            {
                              key: "extra",
                              fn: function () {
                                return [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          _vm.catalogVisible = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("message.openTheCatalog")
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.isModalShow
                  ? _c(
                      "Modal2",
                      {
                        attrs: {
                          id: "catalog-form",
                          title: _vm.$t("message.changeTitle"),
                          "show-footer": false,
                          size: "lg",
                          role: "dialog",
                          "aria-labelledby": "myModalLabel",
                        },
                        on: { cancel: _vm.hideModal },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { md: "12" } },
                                      [
                                        _c("MultiContent", {
                                          ref: "MultiContent",
                                          model: {
                                            value: _vm.catalogGeneralTitle,
                                            callback: function ($$v) {
                                              _vm.catalogGeneralTitle = $$v
                                            },
                                            expression: "catalogGeneralTitle",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { md: "12" } }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "catalog-action-buttons",
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticStyle: {
                                                "margin-right": "6px",
                                              },
                                              on: {
                                                click:
                                                  _vm.titleModalCancelClickHandler,
                                              },
                                            },
                                            [
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(
                                                      _vm.$t("message.cancel")
                                                    ) +
                                                    "\n                                            "
                                                ),
                                              ],
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "primary" },
                                              on: {
                                                click: _vm.handleTitleSave,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.$t("message.update")
                                                  ) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isTitleModal
                  ? _c(
                      "Modal2",
                      {
                        attrs: {
                          id: "catalog-form",
                          title: "Visitor Ekranı İsimlendirme",
                          "show-footer": false,
                          size: "lg",
                          role: "dialog",
                          "aria-labelledby": "myModalLabel",
                        },
                        on: { cancel: _vm.isTitleModalHide },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "a-form-item",
                              {
                                attrs: {
                                  "validate-status": _vm.errors.first(
                                    "companyName"
                                  )
                                    ? "error"
                                    : "success",
                                  "has-feedback.": "",
                                },
                              },
                              [
                                _c("a-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "Katolog Başlığı giriniz...",
                                    name: "companyName",
                                  },
                                  model: {
                                    value: _vm.catalogMenuTitle,
                                    callback: function ($$v) {
                                      _vm.catalogMenuTitle = $$v
                                    },
                                    expression: "catalogMenuTitle",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAdmin
                  ? _c("ChatBar", { attrs: { visible: false } })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.isAdmin ? _c("ChatBar", { attrs: { visible: false } }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }